const calcNewValue = (value: number) => {
  const MIN_VALUE = 1;
  const BASE_MULTIPLIER = 10;
  const OFFSET = 10;

  return value <= MIN_VALUE
    ? value * BASE_MULTIPLIER
    : (value - MIN_VALUE) * 2 + OFFSET;
};

export const ruleToValueRangeTransformation = (range: (string | number)[]) => {
  const [min, max] = range;
  if (typeof min === 'number' && typeof max === 'number') {
    return [calcNewValue(min), calcNewValue(max)];
  }
  return [min, max];
};

export const valueResolver = (range: number[], apiInfinityValue: number) => {
  const [min, max] = range;
  const MIN_VALUE = 10;
  const MAX_VALUE = 28;
  const BASE_DIVISOR = 10;

  const normalizeValue = (value: number, apiInfinityValue: number) => {
    if (value <= MIN_VALUE) {
      return max / BASE_DIVISOR;
    }
    if (value > MAX_VALUE) {
      return apiInfinityValue;
    }

    return Math.floor((value - MIN_VALUE) / 2) + 1;
  };

  const newMin =
    min <= MIN_VALUE
      ? min / BASE_DIVISOR
      : Math.floor((min - MIN_VALUE) / 2) + 1;

  const newMax = normalizeValue(max, apiInfinityValue);

  return [newMin, newMax];
};
